module.exports = __webpack_public_path__ + "img/image_sobre-sistemacpv.cb8b5e58.png";